export default __webpack_public_path__ + "static/media/Abyssal_Reef_LE.e81bf987.jpg";